import axios from 'axios'

export const GET_ALL_COMPANIES = async () => {
  const allCompaniesResults = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/api/users/getusers`
  )
  return allCompaniesResults
}
